import { createUseStyles } from 'react-jss';
import { Theme } from '@mui/material';

export const useStyles = createUseStyles((theme: Theme) => ({
    createRow: {
        display: 'flex',
        alignItems: 'flex-start',
        gap: 10,
        padding: '14px 20px',
        borderBottom: `1px solid ${theme.custom.color.border}`,
        flexWrap: 'wrap',
        [theme.custom.mq.sm]: { padding: 12 },
    },
    amount: { width: 180, [theme.custom.mq.xs]: { width: '100%' } },
    numeric: { textAlign: 'right', fontVariantNumeric: 'tabular-nums', whiteSpace: 'nowrap' },
    mono: { fontFamily: theme.custom.font.mono, fontSize: 13 },
    busy: { opacity: 0.5, pointerEvents: 'none', transition: 'opacity .2s' },
}));
